// API related actions
export const LOAD_ORDER_DETAIL_REQUEST = '@@toyota/LOAD_ORDER_DETAIL_REQUEST';
export const LOAD_ORDER_DETAIL_SUCCESS = '@@toyota/LOAD_ORDER_DETAIL_SUCCESS';
export const LOAD_ORDER_DETAIL_FAILED = '@@toyota/LOAD_ORDER_DETAIL_FAILED';
// complementary actions
export const SELECT_ORDER = '@@toyota/SELECT_ORDER';
